import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js' //element的组件注册
import 'element-ui/lib/theme-chalk/index.css';//element的css样式
import ElementUI from 'element-ui';

import './util/request' // 引入封装的axios
import './style/global.css' // 全局样式

import componentsInstanllation from './util/instanllation' // 引入全局组件

import './plugins/echart' //引入echarts
Vue.use(componentsInstanllation); // 注册

import elTableInfiniteScroll from "el-table-infinite-scroll";//无限滚动
Vue.use(elTableInfiniteScroll);
Vue.use(ElementUI);
Vue.config.productionTip = false

// import Viewer from 'v-viewer' // 引入预览图片插件
// import 'viewerjs/dist/viewer.css'
// Vue.use(Viewer)
// //配置项
// Viewer.setDefaults({
//   zIndexInline:9999
// })

//  过滤日期为月和日， i为毫秒

Vue.filter('filterDate',(i)=>{
    let filterFarmat = (n) => {
		return n < 10 ? `0${n}` : n
	}
	let time = new Date(parseInt(i) * 1000)
	let [day,month] = [
		filterFarmat(time.getDate()),
		filterFarmat(time.getMonth()+1),
		filterFarmat(time.getFullYear())
	]
	return `${month}月${day}日`
})
// 过滤 年月日 时分秒 后端返回的时间戳是秒，要乘1000
Vue.filter("filterTiem", (val) => {
    let now = new Date(parseInt(val) * 1000);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    month = month < 10 ? `0${month}` : month;
    date = date < 10 ? `0${date}` : date;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    return (
      year + "-" + month + "-" + date + " " + hour + ":" + minute
    );
  });
  // 过滤 年月日 val为毫秒
Vue.filter("filterYMD", (val) => {
    let now = new Date(parseInt(val) * 1000);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    month = month < 10 ? `0${month}` : month;
    date = date < 10 ? `0${date}` : date;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    return (
      year + "-" + month + "-" + date
    );
  });
   // 过滤 月日 val为毫秒
Vue.filter("filterMD", (val) => {
    let now = new Date(parseInt(val) * 1000);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    month = month < 10 ? `0${month}` : month;
    date = date < 10 ? `0${date}` : date;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    return (
      month + "月" + date+"日"
    );
  });


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
